import { Button, Flex, Input, Typography } from 'antd';
import styles from './CommentComposer.module.scss';

const { Text } = Typography;

const MAX_LENGTH = 2000;

type Props = {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  submitting: boolean;
  placeholder?: string;
  maxLength?: number;
};

export const CommentComposer = ({
  value,
  onChange,
  onSubmit,
  submitting,
  placeholder = 'Add a comment...',
  maxLength = MAX_LENGTH,
}: Props) => {
  return (
    <div className={styles.composer}>
      <Input.TextArea
        rows={3}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        maxLength={maxLength}
        placeholder={placeholder}
        disabled={submitting}
      />
      <Flex justify="flex-end" align="center" gap={8} style={{ marginTop: 8 }}>
        <Text type="secondary" style={{ fontSize: 12 }}>
          {value.length} / {maxLength}
        </Text>
        <Button type="primary" onClick={onSubmit} loading={submitting} disabled={!value.trim()}>
          Post
        </Button>
      </Flex>
    </div>
  );
};
